import React, { Children, isValidElement } from 'react';
import { T as Tooltip } from './Tooltip-B50E53VM.js';
import { B as Button } from './Button-DJQVVE0-.js';
import { D as DataListOverflowFade } from './DataListOverflowFade-CTvUuFPy.js';
import { b as getExposedActions } from './DataList.utils-CKHBAG6U.js';
import { u as useDataListLayoutActionsContext } from './DataListLayoutContext-B-xNSmCX.js';
import { D as DataListItemActionsOverflow } from './DataListItemActionsOverflow-CcY2WaXQ.js';

function DataListActions({ children, itemsToExpose = 2, }) {
    const { activeItem } = useDataListLayoutActionsContext();
    const childrenArray = Children.toArray(children).filter(isValidElement);
    const exposedActions = getExposedActions(childrenArray, itemsToExpose);
    childrenArray.splice(0, exposedActions.length);
    return (React.createElement(DataListOverflowFade, null,
        exposedActions.map(({ props }) => {
            if (props.visible && !props.visible(activeItem))
                return null;
            if (!props.icon)
                return null;
            function getActionLabel() {
                if (typeof props.label === "string") {
                    return props.label;
                }
                if (activeItem) {
                    return props.label(activeItem);
                }
            }
            const actionLabel = getActionLabel();
            return (React.createElement(Tooltip, { key: actionLabel, message: actionLabel },
                React.createElement(Button, { icon: props.icon, ariaLabel: actionLabel, onClick: () => {
                        var _a, _b;
                        if (activeItem) {
                            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, activeItem);
                        }
                        else {
                            (_b = props.onClick) === null || _b === void 0 ? void 0 : _b.call(props);
                        }
                    }, type: "secondary", variation: "subtle" })));
        }),
        React.createElement(DataListItemActionsOverflow, { actions: childrenArray })));
}

export { DataListActions as D };
